'use client';

import { FullStory as FS } from '@fullstory/browser';
import { useEffect } from 'react';

import { useAuthData } from '@/hooks/useAuthData';
import { getServerConfig } from '@/utils/config';
import { initFullStory } from '@/utils/fullstory-utils';
import { isUserIndustriousEmployee } from '@/utils/user-utils';

export function FullStory() {
  const { isLoading, email } = useAuthData();
  const { IS_PROD } = getServerConfig();

  useEffect(() => {
    if (!IS_PROD || isLoading) return;

    if (email) {
      const isIndEmployee = isUserIndustriousEmployee(email);

      if (isIndEmployee) {
        return;
      }
    }

    startFSRecording();
  }, [isLoading, email]);

  const startFSRecording = async () => {
    await initFullStory();
    FS('start');
  };

  return null;
}
